import { render } from "./ButtonRepo.vue?vue&type=template&id=54d0271b"
const script = {}

import exportComponent from "/Users/Tomi/Documents/Projects/vue-wallet-connect/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__